import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const HomeRedirect = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect based on user type
  if (user.is_system_admin) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  // Redirect tenant users to their tenant home page
  if (user.tenant_subdomain) {
    return <Navigate to={`/app/${user.tenant_subdomain}/home`} replace />;
  }

  // Fallback to login if no tenant subdomain
  return <Navigate to="/login" replace />;
};

export default HomeRedirect;




